'use strict';

var $ = require('jquery');
var globalisation = require('../../utilities/globalisation');

exports.phoneNumber =  function(value) {
  return /^([\d/\\+\-\.,\[\]\(\)\s]+)$/.test(value);
};

$.validator.addMethod('phone-number', exports.phoneNumber, globalisation.pluraliseAndTranslate('formValidation', 'phoneNumber'));



// WEBPACK FOOTER //
// ./assets/js/validators/phone-number.js